import React, { Component } from 'react';

import {
    Grid,
} from  '@mui/material';

import InputText, { InputSelectNative } from '../../common/Form';
import DatePicker from '../../common/DatePicker';
import Creatable from '../../common/Creatable';
import Dialog from '../../common/Dialog';
import ServiceForm from './ServiceForm';
import FunctionForm from './FunctionForm';

class EmployeeForm extends Component {
    state = { 
        employee_lastname: this.props.employee ? this.props.employee.employee_lastname : "",
        employee_firstname: this.props.employee ? this.props.employee.employee_firstname : "",
        employee_email: this.props.employee ? this.props.employee.employee_email : "",
        employee_matricule: this.props.employee ? this.props.employee.employee_matricule : "",
        employee_gender: this.props.employee ? this.props.employee.employee_gender : "",
        employee_hire_date: this.props.employee ? this.props.employee.employee_hire_date : "",
        employee_service: this.props.employee ? this.props.employee.employee_service : "",
        employee_serviceDisplay: this.props.employee && this.props.employee.employee_service ? {
            value: this.props.employee.employee_service, 
            label: this.props.SERVICES[this.props.employee.employee_service].service_name
        } : {value:"", label:""},
        employee_function: this.props.employee ? this.props.employee.employee_function : "",
        employee_functionDisplay: this.props.employee && this.props.employee.employee_function ? {
            value: this.props.employee.employee_function, 
            label: this.props.FUNCTIONS[this.props.employee.employee_function].function_name
        } : {value:"", label:""},
        employee_salary: this.props.employee ? this.props.employee.employee_salary : "",
        employee_sit_matr: this.props.employee ? this.props.employee.employee_sit_matr : "",
        employee_children: this.props.employee ? this.props.employee.employee_children : "",
        employee_accounting: this.props.employee ? this.props.employee.employee_accounting : "",
        employee_accountingDisplay: this.props.employee && this.props.employee.employee_accounting ? {
            value: this.props.employee.employee_accounting, 
            label: this.props.CATEGORIES.CHILD[this.props.employee.employee_accounting].category_name
        } : {value:"", label:""},
        employee_cnss: this.props.employee ? this.props.employee.employee_cnss : "",
        employee_personal_account: this.props.employee ? this.props.employee.employee_personal_account : "",
        errors:{
            employee_firstname: "",
            employee_lastname: "",
            employee_email: "",
            employee_matricule: "",
            employee_gender: "",
            employee_hire_date: "",
            employee_service: "",
            employee_function: "",
            employee_salary: "",
        },
        formService: false,
        formFunction: false,
        nameNew: ""
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        console.log('====================================');
        console.log({name, value});
        console.log('====================================');
        this.setState({
            [name]: value
        })
    }
    handleChangeDate = (employee_hire_date) => {
        console.log('====================================');
        console.log("CHANGE DATE",{employee_hire_date});
        console.log('====================================');
        
        this.setState({            
            employee_hire_date
        })
    }   

    handleChangeSelect = (option, name) => {
        if(option){
            this.setState({
                [name]: option.value || "",
                [`${name}Display`]: option
            })
        } else {
            this.setState({
                [name]: "",
                [`${name}Display`]: {}
            })
        }
    }
    createNew = (field, name) => {
        this.setState({
            [field]: true,
            nameNew: name
        })
    }
    validate = () => {
        let required = [
            "employee_firstname",
            "employee_lastname",
            "employee_email",
            "employee_matricule",
            "employee_gender",
            "employee_hire_date",
            "employee_service",
            "employee_function",
            "employee_salary",
            "employee_accounting",
            "employee_personal_account"
        ]
        
        let noError = true
        let errors = {}
       
        required.map(field => {
            if(!this.state[field]){ //!\ dates
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
    
        return noError
    }
    handleSubmit = async () => {
        let data = {
            employee_matricule : this.state.employee_matricule.trim(),
            employee_firstname : this.state.employee_firstname.trim(),
            employee_lastname : this.state.employee_lastname.trim().toUpperCase(),
            employee_email : this.state.employee_email.trim(),
            employee_gender : this.state.employee_gender,
            employee_hire_date : this.state.employee_hire_date,
            employee_service : this.state.employee_service,
            employee_function : this.state.employee_function,
            employee_salary : parseFloat(this.state.employee_salary),
            employee_children : parseInt(this.state.employee_children),
            employee_sit_matr : this.state.employee_sit_matr,
            employee_accounting : this.state.employee_accounting,
            employee_cnss : this.state.employee_cnss.trim(),
            employee_personal_account : this.state.employee_personal_account.trim(),
        }

        console.log('====================================');
        console.log({data});
        console.log('====================================');
        if(this.validate()){

            await this.props.newEmployee(data)  
            if(this.props.STATE.employees.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.employees.error}`)
            } else{
                this.props.notif("success", "Créé avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    handleSubmitUpdate = async () => {
        let data = Object.assign({}, this.props.employee)
    
        data.employee_matricule = this.state.employee_matricule.trim()
        data.employee_firstname = this.state.employee_firstname.trim()
        data.employee_lastname = this.state.employee_lastname.trim().toUpperCase()
        data.employee_email = this.state.employee_email.trim()
        data.employee_gender = this.state.employee_gender
        data.employee_hire_date = this.state.employee_hire_date
        data.employee_service = this.state.employee_service
        data.employee_function = this.state.employee_function
        data.employee_salary = parseFloat(this.state.employee_salary)
        data.employee_children = parseInt(this.state.employee_children)
        data.employee_sit_matr = this.state.employee_sit_matr
        data.employee_accounting = this.state.employee_accounting
        data.employee_cnss = this.state.employee_cnss.trim()
        data.employee_personal_account = this.state.employee_personal_account.trim()

        console.log('====================================');
        console.log({data});
        console.log('====================================');
        if(this.validate()){

            await this.props.updateEmployee(data)  
            if(this.props.STATE.employees.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.employees.error}`)
            } else{
                this.props.notif("success", "Modifié avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        const { CATEGORIES, FUNCTIONS, SERVICES, STATE } = this.props;
        const { formService, formFunction, nameNew } = this.state;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return(
            <Dialog
                close={this.props.handleClose}
                fullWidth
                maxWidth="md"
                appBar
                title="Créer Employé.e"
                submitAction={this.props.update ? this.handleSubmitUpdate : this.handleSubmit}
                disabledSumit={this.props.STATE.employees.fetching}
            >

                {formService &&
                    <ServiceForm
                        SERVICES={SERVICES}
                        STATE={STATE}
                        service={{service_name: nameNew}}
                        handleClose={() => this.setState({ formService: false, nameNew: "" })}
                        newService={this.props.newService}
                        notif={this.props.notif}
                    />
                }
                {formFunction &&
                    <FunctionForm
                        FUNCTIONS={FUNCTIONS}
                        STATE={STATE}
                        function={{function_name: nameNew}}
                        handleClose={() => this.setState({ formFunction: false, nameNew: "" })}
                        newFunction={this.props.newFunction}
                        notif={this.props.notif}
                    />
                }

                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="employee_lastname" 
                            id="employee_lastname" 
                            value={this.state.employee_lastname} 
                            label="Nom" 
                            error={this.state.errors.employee_lastname} 
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="employee_firstname" 
                            id="employee_firstname" 
                            value={this.state.employee_firstname} 
                            label="Prénom(s)" 
                            error={this.state.errors.employee_firstname} 
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="employee_email" 
                            id="employee_email" 
                            value={this.state.employee_email} 
                            label="Email" 
                            type="email"
                            error={this.state.errors.employee_email} 
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <InputSelectNative
                            id="employee_gender"
                            name="employee_gender"
                            label="Civilité"
                            required
                            error={this.state.errors.employee_gender}
                            value={this.state.employee_gender}
                            onChange={this.handleChange}
                            options={[
                                <option value="female">Mme</option>,
                                <option value="male">M</option>,
                                <option value="other">Autre</option>,
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputSelectNative
                            id="employee_sit_matr"
                            name="employee_sit_matr"
                            label="Situation Matrimoniale"
                            value={this.state.employee_sit_matr}
                            onChange={this.handleChange}
                            options={[
                                <option value="CÉLIBATAIRE">CÉLIBATAIRE</option>,
                                <option value="MARIÉ">MARIÉ</option>,
                                <option value="AUTRE">AUTRE</option>,
                            ]}
                            // error={this.state.errors.employee_sit_matr}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <InputText
                            name="employee_children" 
                            id="employee_children" 
                            value={this.state.employee_children} 
                            label="Nombre d'enfants" 
                            onChange={this.handleChange}
                            type="number"
                            // error={this.state.errors.employee_children} 
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <DatePicker  
                            required
                            id="employee_hire_date" 
                            label="Date d'Embauche" 
                            name="employee_hire_date" 
                            value={this.state.employee_hire_date} 
                            handleChange={this.handleChangeDate} 
                            error={this.state.errors.employee_hire_date}
                            maxDate={new Date()}
                        />      
                    </Grid>    
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="employee_matricule" 
                            id="employee_matricule" 
                            value={this.state.employee_matricule} 
                            label="Matricule" 
                            error={this.state.errors.employee_matricule} 
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Creatable
                            required
                            label="Service"
                            error={this.state.errors.employee_service}
                            id="employee_service"
                            options={Object.values(SERVICES).map( item => ({
                                label: item.service_name,
                                value: item.service_id
                            }))}
                            value={this.state.employee_serviceDisplay}
                            openPopUp={(name) => this.createNew("formService", name)}
                            onChange={(option) => this.handleChangeSelect(option, "employee_service" )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {/* <InputText
                            required
                            name="employee_function" 
                            id="employee_function" 
                            value={this.state.employee_function} 
                            label="Fonction" 
                            error={this.state.errors.employee_function} 
                            onChange={this.handleChange}
                        /> */}
                        <Creatable
                            required
                            label="Fonction"
                            error={this.state.errors.employee_function}
                            id="employee_function"
                            options={Object.values(FUNCTIONS).map( item => ({
                                label: item.function_name,
                                value: item.function_id
                            }))}
                            value={this.state.employee_functionDisplay}
                            openPopUp={(name) => this.createNew("formFunction", name)}
                            onChange={(option) => this.handleChangeSelect(option, "employee_function" )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            name="employee_cnss" 
                            id="employee_cnss" 
                            value={this.state.employee_cnss} 
                            label="N°CNSS" 
                            error={this.state.errors.employee_cnss} 
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Creatable
                            label="Compte Salaire"
                            required
                            error={this.state.errors.employee_accounting}
                            id="employee_accounting"
                            options={Object.values(CATEGORIES.CHILD).filter(c => c.is_active !== false).map( item => ({
                                label: `${item.category_accounting_id} - ${item.category_name}`,
                                // label: item.category_name,
                                value: item.category_id
                            }))}
                            value={this.state.employee_accountingDisplay}
                            openPopUp={this.props.createNewCategory}
                            onChange={(option) => this.handleChangeSelect(option, "employee_accounting" )}
                            // {...this.props}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="employee_personal_account" 
                            id="employee_personal_account" 
                            value={this.state.employee_personal_account} 
                            label="Compte Employee" 
                            error={this.state.errors.employee_personal_account} 
                            onChange={this.handleChange}
                            placeholder="422..."
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <InputText
                            required
                            name="employee_salary" 
                            id="employee_salary" 
                            value={this.state.employee_salary} 
                            label="Salaire de Base" 
                            error={this.state.errors.employee_salary} 
                            onChange={this.handleChange}
                            type="number"
                        />
                    </Grid>
                </Grid>
            </Dialog>
        )
    }
}

export default EmployeeForm;